<template>
    <div class="webhook-data-item">
        <CustomPicker
            v-model="clone.field"
            :items="fields"
            idKey="id"
            labelKey="label"
            title="Select Field"
            style="width: 250px"
        />
        <TiptapEditor placeholder="Value" :show-attributes="true" v-model="clone.value" automation-mode />
        <SupsisButton small danger @click="deleteItem" v-if="isDeleteButtonVisible"
            ><i class="material-icons">delete</i></SupsisButton
        >
    </div>
</template>
<script>
import Vue from "vue";
import TiptapEditor from "../../../../../Chatbot/pages/dashboard/common/TiptapEditor.vue";
import StringUtils from "../../../../../../../utils/StringUtils";
import SupsisButton from "../../../../../Settings/components/SupsisButton.vue";
import CustomPicker from "../../../../../../../components/pickers/CustomPicker.vue";
import _ from "lodash";

export default Vue.extend({
    name: "UpdateInfo",
    components: { SupsisButton, TiptapEditor, CustomPicker },
    props: ["payload", "fields", "isDeleteButtonVisible"],
    data() {
        const clone = _.cloneDeep(this.payload) || {
            field: null,
            value: null,
        };
        return {
            clone,
        };
    },
    methods: {
        deleteItem() {
            this.$emit("delete");
        },
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("save", newValue);
            },
        },
    },
});
</script>

<style scoped lang="scss">
.webhook-data-item {
    display: flex;
    flex-direction: row;
    gap: 10px;
}
</style>
